import React from "react";
import PropTypes from "prop-types";
import { WithLazy } from "@quintype/components";

let taboolaStarted = false;
function startTaboola() {
  if (taboolaStarted) {
    return;
  }

  taboolaStarted = true;

  // eslint-disable-next-line no-unused-expressions
  !(function(e, f, u, i) {
    if (!document.getElementById(i)) {
      e.src = u;
      e.id = i;
      e.defer = true;
      f.parentNode.insertBefore(e, f);
    }
  })(
    document.createElement("script"),
    document.getElementsByTagName("script")[0],
    "//cdn.taboola.com/libtrc/vikatan-vikatan/loader.js",
    "tb_loader_script"
  );
  if (window.performance && typeof window.performance.mark === "function") {
    window.performance.mark("tbl_ic");
  }
}

class TaboolaAdBase extends React.Component {
  static counter = 1;
  constructor() {
    super();
    this.counter = TaboolaAd.counter++;
  }
  componentDidMount() {
    startTaboola();
    global._taboola = global._taboola || [];
    global._taboola.push({
      mode: `${this.props.config.mode}`,
      container: `${this.props.config.id}-${this.counter}`,
      placement: `${this.props.config.placement}`,
      target_type: "mix"
    });
    if (this.props.url) {
      global._taboola.push({ article: "auto", url: this.props.url });
    }
    global._taboola.push({ flush: true });
  }

  shouldComponentUpdate(nextProps) {
    return this.props.config.id !== nextProps.config.id;
  }

  render() {
    return (
      <div className={`container ${this.props.className}`} style={{ margin: "0 0 var(--space-2)" }}>
        <div id={`${this.props.config.id}-${this.counter}`} />
      </div>
    );
  }
}

TaboolaAdBase.propTypes = {
  config: PropTypes.shape({
    mode: PropTypes.string,
    id: PropTypes.string,
    placement: PropTypes.string
  }),
  url: PropTypes.string,
  className: PropTypes.string
};

export function TaboolaAd(props) {
  return <WithLazy margin="200px">{() => <TaboolaAdBase {...props} />}</WithLazy>;
}
